// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".colors-wrap{display:flex;flex-wrap:wrap;max-width:320px}.colors-wrap .color-square{cursor:pointer;height:25px;margin:0 10px 10px 0;transition:.4s;width:25px}.colors-wrap .color-square:last-child{border:1px solid #000}.colors-wrap .color-square.active{transform:scale(1.25)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
